import { combineReducers } from "redux";

const authReducer = (state = [], action) => {
  switch (action.type) {
    case "LOGIN":
          return { username: action.payload.username, token: action.payload.token, refresh: action.payload.refresh };
    case "LOGOUT":
      return {};
    default:
      return state;
  }
};

const headerReducer = (state = { isOpen: false }, action) => {
  switch (action.type) {
    case "TRIGGER_SIDEBAR_MENU":
          return { isOpen: action.payload };
    default:
      return state;
  }
};


const stateReducer = (state = [{ showReadonly: false }],action) => {
    switch (action.type) {
        case "TRIGGER_READONLY_POPUP":
            return { showReadonly: action.payload };
        default:
            return state;
    }
};


const rootReducer = combineReducers({
    auth: authReducer,
    header: headerReducer,
    states: stateReducer
});


export default rootReducer;
